import React from 'react';
import { useUpdateAsoRequestMutation } from '../apiAso';
import EditAsoModal from '../modals/EditAsoModal';

interface EditAsoRequestModalProps {
  open: boolean;
  requestId: number;
  currentName?: string;
  onCancel: () => void;
}

const EditAsoRequestModal: React.FC<EditAsoRequestModalProps> = ({
  open,
  requestId,
  currentName,
  onCancel,
}) => {
  const [updateAsoRequest, { isLoading: confirmLoading }] = useUpdateAsoRequestMutation();

  const modalTitle = `Edit ASO request #${requestId}${currentName ? ` ${currentName}` : ''}`;

  return (
    <EditAsoModal
      open={open}
      currentName={currentName}
      onCancel={onCancel}
      modalTitle={modalTitle}
      formDataType="edit-aso-request-form"
      formName="edit_aso_request_modal"
      nameRequiredMessage="Please enter a name for your ASO request"
      confirmLoading={confirmLoading}
      onSubmit={name => updateAsoRequest({ id: requestId, payload: { name } })}
    />
  );
};

export default EditAsoRequestModal;
